import {albumsOutline, business, callSharp, checkmarkCircleSharp, clipboard, cloudUploadOutline, cogOutline, cogSharp, document, documentOutline, fileTrayFullOutline, homeOutline, homeSharp, information, keyOutline, libraryOutline, listCircleOutline, listOutline, lockClosedSharp, logOutSharp, mailSharp, options, people, peopleCircle, peopleOutline, personSharp, phonePortraitOutline, playCircleOutline, ribbon, storefront, trashOutline, wallet, createOutline} from "ionicons/icons";
import barn from "../assets/img/icons/barn.svg";

export interface Page {
    title: string;
    description?: string;
    path: string;
    icon?: string;
    img?: any;
    isOrganizationPagePresent?: boolean;
}

export const pages: Page[] = [
    {title: "Home", path: "/", icon: "home"},
    {title: "About", path: "/about", icon: "information"},
];

export const mainMenuOptions: Page[] = [
    {title: "Dashboard", path: "home", icon: homeSharp, isOrganizationPagePresent: true},
    {title: "All Events", path: "events", icon: ribbon, isOrganizationPagePresent: false},
    {title: "My Barn", path: "barn", icon: undefined, img: barn, isOrganizationPagePresent: false}
];

export const eventMenuOptions: Page[] = [
    {title: "Events", path: "/index/staff/events", icon: ribbon},
    {title: "Organizations", path: "/index/staff/organization", icon: business}
];

export const organizationListOptions: Page[] = [
    {title: "Basic Settings", description: "Info, logos, colors, subscription settings", path: "/index/staff/organization/basic-settings", icon: information},
    {title: "Event Settings", description: "class/division lists, templates", path: "/index/staff/organization/event-settings", icon: options},
    {title: "Org Text Alerts", description: "send text alerts to subscribers in your organization", path: "/index/staff/organization/text-alerts", icon: phonePortraitOutline},
    {title: "Addresses", description: "mailing, billing", path: "/index/staff/organization/addresses", icon: storefront},
    {title: "Members", description: "manage admin and general org members", path: "/index/staff/organization/members", icon: people},
    {title: "Points Tracking", description: "track points awarded at organization events", path: "/index/staff/organization/points", icon: ribbon},
    {title: "Financial Info", description: "payment methods, pay out settings", path: "/index/staff/organization/finance", icon: wallet},
];

export const organizationBasicSettingsListOptions: Page[] = [
  {title: "Basic Info", description: "name, description, type, industry", path: "/index/staff/organization/info", icon: information},
  {title: "Addresses", description: "mailing, billing", path: "/index/staff/organization/addresses", icon: storefront},
  {title: "Branding", description: "Logos, colors, URL", path: "/index/staff/organization/branding", icon: storefront},
  {title: "Subscription", description: "View subscription details or make changes", path: "/index/staff/organization/subscription", icon: storefront},
  {title: "Delete Organization", description: "remove this organization and its data", path: "/index/staff/organization/delete", icon: trashOutline}
];

export const organizationEventSettingsListOptions: Page[] = [
    // {title: "Event Templates", description: "Example: Schooling Show Template or USEF Rated Show Template", path: "/index/staff/organization/event-templates", icon: document},
    // {title: "Division & Class Templates", description: "Allows you to reuse divisions and classes across events", path: "/index/staff/organization/division-templates", icon: document},
    {title: "Organization Seasons", description: "Allows you to organize data by season", path: "/index/staff/organization/org-seasons", icon: document},
    {title: "Organization Divisions", description: "Allows you to create division and class templates", path: "/index/staff/organization/org-divisions", icon: document},
    {title: "Point Templates", description: "Allows you to reuse point tables.", path: "/index/staff/organization/point-templates", icon: document},
    {title: "Prize Money Templates", description: "Allows you to reuse payout tiers.", path: "/index/staff/organization/prizemoney-templates", icon: document},
    {title: "Organization Stabling", description: "Allows you to reuse stall types and sets plus offer shavings.", path: "/index/staff/organization/stalls", icon: document},
    {title: "Organization Tax Rates", description: "Allows you to reuse tax rates.", path: "/index/staff/organization/tax", icon: document},
];

export const organizationMemberSettingsListOptions: Page[] = [
    {title: "Admin Members", description: "Invite others to manage your organization and events.", path: "/index/staff/organization/members/admin", icon: keyOutline},
    {title: "General Members", description: "View and manage members of your organization", path: "/index/staff/organization/members/general", icon: peopleOutline},
    {title: "Membership Types", description: "Define membership types and costs.", path: "/index/staff/organization/membership-types", icon: listOutline},
    {title: "Membership Communication", description: "Write posts for members to see on their Dashboards", path: "/index/staff/organization/posts", icon: createOutline},
    {title: "Past Event Entries", description: "View past riders and horses that have entered events", path: "/index/staff/organization/members/entries", icon: albumsOutline},
];

export const organizationPointSettingsListOptions: Page[] = [
    {title: "Point Templates", description: "Allows you to reuse point tables.", path: "/index/staff/organization/point-templates", icon: document},
    {title: "View Points Earned", description: "View and manage points earned in your organization", path: "/index/staff/organization/points/view", icon: listOutline},
    {title: "Points Reports", description: "Download reports with various points breakdowns", path: "/index/staff/organization/points/reports", icon: documentOutline},
    {title: "Upload New Point Info", description: "You can upload point data from events not in the system.", path: "/index/staff/organization/points/upload", icon: cloudUploadOutline},
];

export const riderMenuOptions: Page[] = [
    {title: "Rider Profile", path: "/index/rider/profile", icon: personSharp},
    {title: "Your Horses", path: "/index/rider/horses", icon: listOutline},
    {title: "Video Library", path: "/index/library", icon: libraryOutline},
    {title: "Video Feedback", path: "/index/submissions/previous", icon: fileTrayFullOutline},
];

export const riderListOptions: Page[] = [
    {title: "Your Rider Info", description: "your age, amateur status, location, etc", path: "/index/rider/info", icon: information},
    {title: "Your Memberships", description: "USEF, EC or any other membership numbers you have", path: "/index/rider/memberships", icon: listCircleOutline},
    // {title: "Your Calendar", description: "upcoming horse shows, clinics, etc you plan to attend", path: "/index/rider/calendar", icon: calendar}
];

export const ownerMenuOptions: Page[] = [
    {title: "Owner Profile", path: "/index/owner/profile", icon: personSharp},
    {title: "Your Horses", path: "/index/owner/horses", icon: listOutline},
];

export const ownerListOptions: Page[] = [
    {title: "Your Info", description: "your disciplines, location, etc", path: "/index/owner/info", icon: information},
    {title: "Your Memberships", description: "USEF, EC or any other membership numbers you have", path: "/index/owner/memberships", icon: listCircleOutline},
    // {title: "Your Calendar", description: "upcoming horse shows, clinics, etc you plan to attend", path: "/index/owner/calendar", icon: calendar}
];

export const trainerMenuOptions: Page[] = [
    {title: "Trainer Profile", path: "/index/trainer/profile", icon: personSharp},
    {title: "My Barn", path: "/index/staff/barn", icon: homeOutline},
];

export const trainerListOptions: Page[] = [
    {title: "Your Info", description: "your disciplines, location, etc", path: "/index/trainer/info", icon: information},
    {title: "Your Memberships", description: "USEF, EC or any other membership numbers you have", path: "/index/trainer/memberships", icon: listCircleOutline},
    // {title: "Your Calendar", description: "upcoming horse shows, clinics, etc you plan to attend", path: "/index/trainer/calendar", icon: calendar}
];

export const teamMemberProfileOptions: Page[] = [
    {title: "Personal Info", description: "name, picture, roles, birthday", path: "/index/settings/profile", icon: personSharp},
    {title: "Contact Info", description: "email, phone number, mailing address", path: "/index/settings/contact", icon: callSharp},
];

export const barnMenuOptions: Page[] = [
    {title: "My Barn", path: "/index/barn/events", icon: ribbon}
];

export const barnAdminListOptions: Page[] = [
    {title: "Basic Info", description: "name, description, industry", path: "/index/barn/admin/info", icon: information},
    {title: "Horses", description: "horse info, saved in one place", path: "/index/barn/admin/horses", icon: listOutline},
    {title: "People", description: "rider, owner and trainer info, saved in one place", path: "/index/barn/admin/people", icon: people},
    {title: "Settings", description: "remove this barn", path: "/index/barn/admin/settings", icon: cogOutline}
];


export const barnListOptions: Page[] = [
    {title: "Basic Info", description: "name, description, industry", path: "/index/barn/member/info", icon: information},
    {title: "Horses", description: "horse info, saved in one place", path: "/index/barn/member/horses", icon: listOutline},
    {title: "People", description: "rider, owner and trainer info, saved in one place", path: "/index/barn/member/people", icon: people},
    {title: "Barn Settings", description: "remove this barn", path: "/index/barn/admin/settings", icon: cogOutline}
];

export const teamListOptions: Page[] = [
    {title: "Basic Info", description: "name, address, contact info", path: "/index/team/info", icon: information},
    {title: "Coaches", description: "coach names and contact info", path: "/index/team/coaches", icon: listOutline},
    {title: "Roster", description: "roster of athletes", path: "/index/team/roster", icon: people},
];

export const adminMenuOptions: Page[] = [
    {title: "Dashboard", path: "/index/admin/dashboard", icon: homeSharp},
    {title: "Users", path: "/index/admin/users", icon: peopleCircle},
    {title: "Barn Management", path: "/index/admin/barns", icon: homeOutline},
    {title: "Event Management", path: "/index/admin/events", icon: clipboard},
    {title: "Org Management", path: "/index/admin/orgs", icon: business},
    {title: "Credit Management", path: "/index/admin/credits", icon: wallet},
    {title: "Clinic Management", path: "/index/admin/clinics", icon: playCircleOutline},
];

export const judgeMenuOptions: Page[] = [
    {title: "Online Clinics", path: "/index/judge/clinics", icon: playCircleOutline}
];

export const clinicianMenuOptions: Page[] = [
    {title: "My Profile", description: "about, video pricing, video preferences, etc.", path: "/index/judge/clinics/profile", icon: personSharp},
    {title: "Status", description: "ability to accept new videos", path: "/index/judge/clinics/status", icon: checkmarkCircleSharp},
    {title: "Videos", description: "all videos submitted to you for feedback", path: "/index/judge/clinics/videos", icon: playCircleOutline},
    {title: "Payments", description: "payment preferences, payment tracker", path: "/index/judge/clinics/payment", icon: wallet},
];

export const finalMenuOptions: Page[] = [
    {title: "Settings", path: "/index/settings", icon: cogSharp},
    {title: "Log Out", path: "/index/logout", icon: logOutSharp}
];

export const settingsOptions: Page[] = [
    {title: "Edit Personal Info", description: "name, picture, roles, birthday", path: "/index/settings/profile", icon: personSharp},
    {title: "Edit Contact Info", description: "email, phone number, mailing address", path: "/index/settings/contact", icon: callSharp},
    {title: "Notification Preferences", description: "news, offers, receipts", path: "/index/settings/preferences", icon: mailSharp},
    {title: "Security", description: "password, delete account", path: "/index/settings/security", icon: lockClosedSharp},
    {title: "Log Out", path: "/index/logout", icon: logOutSharp},
];